import React, { useContext } from 'react'
import BidButton from '../../../../../elements/BidButton/BidButton'
import _isNumber from 'lodash/isNumber'
import LoginRedirect from '@components/LoginRedirect'
import BiddingButtons from '@components/BiddingButtons'
import { AuthContext } from '../../../../../contexts/AuthContext'
import { ItemState } from '@components/ItemPage/utils/types'

const Bidding = ({
  itemState,
  itemHandler,
  modal,
  auction,
  loadingBid,
  setLoadingBid,
}: {
  itemState: ItemState
  itemHandler: any
  modal: any
  auction: any
  loadingBid: any
  setLoadingBid: any
}) => {
  const {
    isAuthenticated,
    userData: {
      profile: { isAddedCard },
    },
  } = useContext<any>(AuthContext)
  const {
    itemClosed,
    bidsEnabled,
    binEnabled,
    maoEnabled,
    currentBid,
    removed,
    binPrice,
    palletLot,
  } = itemState
  const {
    state: { binMade, offerMade, showViewBtn },
    handlers: { setModalAction, setModalData, toggleModal, handleBtnClick },
  } = modal
  return (
    <>
      {!itemClosed &&
        !removed &&
        (currentBid === 0 || currentBid) &&
        bidsEnabled && (
          <BiddingButtons
            item={itemState}
            updateItem={itemHandler.updateItem}
            auctionTypeId={auction?.auctionTypeId}
            auctionId={auction.id}
            location={auction?.location}
            loadingBid={loadingBid}
            setLoadingBid={setLoadingBid}
            toggleModal={toggleModal}
            setModalAction={setModalAction}
            setModalData={setModalData}
            isItemDetail
          />
        )}
      {(binEnabled || maoEnabled) && (
        <>
          {showViewBtn && (
            <div className="grid grid-cols-2 gap-3 items-center mb-3">
              <BidButton
                label="View"
                theme="blue-dark"
                callBack={() => toggleModal(true, 'View')}
                width="full"
              />
            </div>
          )}
          {isAuthenticated ? (
            !isAddedCard ? (
              <BidButton
                label="Add Card to Bid"
                theme="blue-light"
                link="/account/dashboard/cards"
                type="link"
                width="full"
              />
            ) : (
              <>
                <div className="grid grid-cols-2 gap-3 items-center">
                  <div
                    className={`${
                      !binEnabled || binMade || itemClosed ? 'hidden' : ''
                    }`}
                  >
                    <BidButton
                      label={`Buy It Now $${
                        _isNumber(binPrice) ? binPrice.toFixed(2) : ''
                      }`}
                      theme="blue-light"
                      callBack={() => handleBtnClick('bin')}
                      width="full"
                    />
                  </div>
                  <div
                    className={`${!maoEnabled || offerMade ? 'hidden' : ''}`}
                  >
                    <BidButton
                      label="Make an Offer"
                      theme="blue"
                      callBack={() => handleBtnClick('mao')}
                      width="full"
                    />
                  </div>
                </div>
              </>
            )
          ) : (
            <LoginRedirect />
          )}
        </>
      )}

      {palletLot && (
        <BidButton
          label="View Lot Detail"
          theme="blue-extra-light"
          callBack={() => toggleModal(true, 'ViewPalletLot')}
          width="full"
          size="lg"
        />
      )}
    </>
  )
}

export default Bidding
